export default (that) => [
  {
    text: that.$l('menu_text_detail') || '查看订单',
    icon: 'el-icon-view',
    menuType: 'detail',
  },
  {
    text: that.$l('menu_text_edit') || '编辑订单',
    icon: 'el-icon-edit',
    menuType: 'edit',
    divided: true,
    allow: 'M',
    disabled: ({ evgBulkOrderStatus }) => !['N'].includes(evgBulkOrderStatus),
  },
  {
    text: that.$l('menu_text_delete') || '删除订单',
    icon: 'el-icon-delete',
    menuType: 'delete',
    divided: false,
    allow: 'D',
    disabled: ({ evgBulkOrderStatus }) => !['N'].includes(evgBulkOrderStatus),
  },
  {
    text: that.$l('menu_text_copy') || '复制订单',
    icon: 'el-icon-document-copy',
    menuType: 'copy',
    divided: true,
    allow: 'P',
    disabled: ({ evgBulkOrderStatus }) => ['D'].includes(evgBulkOrderStatus),
  },
  {
    text: that.$l('menu_text_audit') || '审核订单',
    icon: 'el-icon-check',
    menuType: 'audit',
    divided: true,
    allow: 'C',
    disabled: ({ evgBulkOrderStatus }) => !['N'].includes(evgBulkOrderStatus),
  },
  {
    text: that.$l('menu_text_rollback_request') || '提交回退申请',
    icon: 'el-icon-refresh-left',
    menuType: 'rollback',
    divided: true,
    allow: 'R',
    disabled: ({ evgBulkOrderStatus }) => !['Y'].includes(evgBulkOrderStatus),
  },
]
